import * as React from "react";
import { Link } from "react-router";

type Props = {
    to: any;
    children: React.ReactNode;
    customClass?: string | null;
    onClick?: (event?: any) => void;
};

function LinkContainerWrapper(props: Props & { [k: string]: any }) {
    const { to, customClass, ...newProps } = props as any;
    newProps.className = customClass + (newProps.className || "");
    return (
        <Link to={to || ""} {...newProps} onClick={props.onClick}>
            {props.children}
        </Link>
    );
}

LinkContainerWrapper.defaultProps = {
    customClass: "ex-linkcontainer "
};

export default LinkContainerWrapper;
